<template>
  <div>
    <div class="row mt10 name-box">
      <div class="col-md-12">
        <div class="row">
          <router-link :to="localizedRoute(designerCategoryPath + '?' + designerAttribute + '=' + getCurrentProduct[designerAttribute])" class="fs-medium-small weight-400 cl-black author uppercase pl10">
            {{ designerCheck }}
          </router-link>
          <div id="6ea25396-b018-405b-8836-c37b4597eb3c" />
          <script defer type="application/javascript" :src="`https://trustmate.io/api/widget/6ea25396-b018-405b-8836-c37b4597eb3c/script?product=${getCurrentProduct.parentSku}`" />
        </div>
        <h1 class="mb0 mt0 product-name weight-600 serif capitalize">
          {{ getCurrentProduct.name | htmlDecode }}
          <AddToWishlist :product="getCurrentProduct" class="wishlist-button" />
        </h1>
        <slot />
      </div>
    </div>
    <slot name="options" />
  </div>
</template>

<script>
import { ProductMixin } from 'theme/components/core/blocks/Product-v2/ProductMixin.ts'

export default {
  name: 'BaseConfigurableProduct',
  mixins: [ProductMixin]
}
</script>

<style lang="scss" scoped>
.name-box {
  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
}
.product-name {
  font-size: 28px;
  font-weight: 500;
  position: relative;
  .wishlist-button {
    position: absolute;
    right: 0;
    top: -7px;
  }
  @media (max-width: 767px) {
    font-size: 26px;
  }
}
</style>
